import Vue from 'vue'

export const update = (state, data) => {
  Vue.set(state, data['cmp'], data['payload'])
}



// WEBPACK FOOTER //
// ./src/store/modules/components/mutations.js